import { EventStatus } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
const HEX_COLOR = /^#[0-9A-F]{6}$/i;
export const createEventSchema = z.object({
    adminId: z.string(),
    calendarEventTemplateId: z.string().optional(),
    allDay: z.boolean().optional(),
    color: z
        .string()
        .regex(HEX_COLOR, 'La couleur doit être au format hexadécimal (#RRGGBB)')
        .optional(),
    description: z.string().max(8000).optional(),
    endDate: z.coerce.date(),
    isOffPeriod: z.boolean().optional(),
    isRecurring: z.boolean().optional(),
    location: z.string().max(1024).optional(),
    recurrenceRule: z.string().optional(),
    startDate: z.coerce.date(),
    status: z.nativeEnum(EventStatus).optional(),
    timezone: z.string().optional(),
    title: z.string().min(1, 'Le titre est requis').max(1024),
});
export const eventFiltersSchema = z.object({
    adminId: z.string().optional(),
    endDate: z.coerce.date().optional(),
    startDate: z.coerce.date().optional(),
    status: z.nativeEnum(EventStatus).optional(),
});
// Shared { adminId, date } shape used by AssignmentDto and BatchDeleteAssignmentDto.
export const templateAssignmentSchema = z.object({
    adminId: z.string(),
    date: isoDateString(),
});
export const batchAssignTemplateSchema = z.object({
    templateId: z.string(),
    assignments: z.array(templateAssignmentSchema).min(1),
});
export const deleteTemplateEventsSchema = z.object({
    adminId: z.string(),
    templateId: z.string().optional(),
    date: isoDateString(),
});
export const batchDeleteTemplateEventsSchema = z.object({
    templateId: z.string().optional(),
    assignments: z.array(templateAssignmentSchema).min(1),
});
export const createTimeRangeSchema = z.object({
    color: z.string().regex(HEX_COLOR, 'La couleur doit etre au format hexadecimal (#RRGGBB)'),
    description: z.string().max(1000).optional(),
    endHour: z.number().min(0).max(23.99),
    isOffPeriod: z.boolean().optional(),
    startHour: z.number().min(0).max(23.99),
    title: z.string().min(1).max(255),
});
export const createCalendarEventTemplateSchema = z.object({
    name: z.string().min(1).max(255),
    color: z.string().optional(),
    description: z.string().max(1000).optional(),
    disableGoogleSync: z.boolean().optional(),
    isFullDay: z.boolean(),
    isOffPeriod: z.boolean().optional(),
    timeRanges: z.array(createTimeRangeSchema),
});
